import React from 'react';
import { DebateWindow, Empty } from 'components/common/'


const TabDebates = ({ debates }) => {
    return debates?.length > 0 ? debates?.map((i, k) => (
        <DebateWindow key={k} debate={i} />
    )) : <Empty className={'account'} />
}

export default TabDebates